import ConfirmModal from 'components/ConfirmModal';
import React from 'react';
import Button, { ButtonProps } from './Button';

type Props = ButtonProps & {
  confirmMessage: string | (() => JSX.Element);
  confirmTitle?: string;
};

const ButtonWithConfirm: React.FC<Props> = ({
  confirmTitle,
  confirmMessage,
  ...props
}) => {
  if (!props.onClick) {
    return <Button {...props} />;
  }
  return (
    <ConfirmModal
      message={confirmMessage}
      title={confirmTitle}
      onConfirm={props.onClick}
      confirmLoading={props.loading || false}
      renderButton={({ openModal }) => (
        <Button {...props} onClick={openModal}>
          {props.children}
        </Button>
      )}
    />
  );
};

export default ButtonWithConfirm;
